// extracted by mini-css-extract-plugin
export default {"header":"styles_header__sCPBs","animation":"styles_animation__jBB9B","animationImg":"styles_animationImg__WsqNV","fade":"styles_fade__i-fBZ","iLogo":"styles_iLogo__OiMmX"};